<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Global Engagement
        <small>3 Month Snapshot</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>Dashboard</li>
        <li class="active">Engagement</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- BAR CHART -->
          <div class="box box-success">
            <div class="box-header with-border">
              <h3 class="box-title"><i class="fa fa-bar-chart"></i> Weekly Snapshot</h3>

              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                </button>
                <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
              </div>
            </div>
            <div class="box-body">
              <div class="chart-responsive">
                <chartjs-line :labels="weeklyLabels" :datasets="weeklyDatasets" :bind="true"></chartjs-line>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->
        </div>
        <!-- /.col (RIGHT) -->
      </div>
      <div class="row">
        <div class="col-md-12">
          <!-- BAR CHART -->
          <div class="box box-success">
            <div class="box-header with-border">
              <h3 class="box-title"><i class="fa fa-bar-chart"></i> Monthly Snapshot</h3>

              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                </button>
                <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
              </div>
            </div>
            <div class="box-body">
              <div class="chart-responsive">
                <chartjs-line :labels="monthlyLabels" :datasets="monthlyDatasets" :bind="true"></chartjs-line>
                <!-- <chartjs-bar :labels="monthlyLabels" :datasets="monthlyDatasets" :bind="true"></chartjs-bar> -->
              </div>
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->
        </div>
        <!-- /.col (RIGHT) -->
      </div>
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
  import {
    getWeeklySnapshot, getMonthlySnapshot
  }
    from '../../../utils/stats'
  export default {
    name: 'app-engagement',
    data () {
      return {
        responseData: '',
        label: '#',
        weeklyLabels: [],
        labels: ['users', 'referrals', /* 'referrals without facilities', 'referrals with facilities', */ 'redeemed referrals', 'completed feedback'],
        weeklyDatasets: [
          {
            label: 'Users',
            backgroundColor: '#f19c12',
            borderWidth: 2,
            borderColor: '#f19c12',
            lineTension: 0.1,
            fill: false,
            data: []
          },
          {
            label: 'Referrals',
            backgroundColor: '#57c1f0',
            borderWidth: 2,
            borderColor: '#57c1f0',
            lineTension: 0.1,
            fill: false,
            data: []
          },
          /* {
            label: 'Referrals without Facilities',
            backgroundColor: '#dd4c3a',
            borderWidth: 2,
            borderColor: '#dd4c3a',
            lineTension: 0.1,
            fill: false,
            data: []
          },
          {
            label: 'Referrals with Facilities',
            backgroundColor: '#52a75a',
            borderWidth: 2,
            borderColor: '#52a75a',
            lineTension: 0.1,
            fill: false,
            data: []
          }, */
          {
            label: 'Redeemed Referrals',
            backgroundColor: 'blue',
            borderWidth: 2,
            borderColor: 'blue',
            lineTension: 0.1,
            fill: false,
            data: []
          },
          {
            label: 'Completed Feedback',
            backgroundColor: 'purple',
            borderWidth: 2,
            borderColor: 'purple',
            lineTension: 0.1,
            fill: false,
            data: []
          }
        ],
        monthlyLabels: [],
        monthlyDatasets: [
          {
            label: 'Users',
            backgroundColor: '#f19c12',
            borderColor: '#f19c12',
            borderWidth: 2,
            data: [],
            fill: false
          },
          {
            label: 'Referrals',
            backgroundColor: '#57c1f0',
            borderColor: '#57c1f0',
            borderWidth: 2,
            data: [],
            fill: false
          },
          /* {
            label: 'Referrals without Facilities',
            backgroundColor: '#dd4c3a',
            borderColor: '#dd4c3a',
            borderWidth: 2,
            fill: false,
            data: []
          },
          {
            label: 'Referrals with Facilities',
            backgroundColor: '#52a75a',
            borderColor: '#52a75a',
            borderWidth: 2,
            fill: false,
            data: []
          }, */
          {
            label: 'Redeemed Referrals',
            backgroundColor: 'blue',
            borderColor: 'blue',
            borderWidth: 2,
            fill: false,
            data: []
          },
          {
            label: 'Completed Feedback',
            backgroundColor: 'purple',
            borderColor: 'purple',
            borderWidth: 2,
            fill: false,
            data: []
          }
        ]
      }
    },
    mounted () {
      getWeeklySnapshot().then((response) => {
        let { data } = response.data
        for (let i = data.length - 1; i >= 0; i--) {
          this.weeklyLabels.push(data[i].displayName)
          this.weeklyDatasets[0].data.push(data[i].value.accounts)
          this.weeklyDatasets[1].data.push(data[i].value.referrals)
          // this.weeklyDatasets[2].data.push(data[i].value.referrals_without_facilities)
          // this.weeklyDatasets[2].data.push(data[i].value.referrals_with_facilities)
          this.weeklyDatasets[2].data.push(data[i].value.redemptions)
          this.weeklyDatasets[3].data.push(data[i].value.feedbacks)
        }
      }).catch(function (error) {
        console.log(error)
      })
      getMonthlySnapshot().then((response) => {
        let { data } = response.data
        for (let i = data.length - 1; i >= 0; i--) {
          this.monthlyLabels.push(data[i].displayName)
          this.monthlyDatasets[0].data.push(data[i].value.accounts)
          this.monthlyDatasets[1].data.push(data[i].value.referrals)
          // this.monthlyDatasets[2].data.push(data[i].value.referrals_without_facilities)
          // this.monthlyDatasets[2].data.push(data[i].value.referrals_with_facilities)
          this.monthlyDatasets[2].data.push(data[i].value.redemptions)
          this.monthlyDatasets[3].data.push(data[i].value.feedbacks)
        }
      }).catch(function (error) {
        console.log(error)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Engagement.vue?8431601a